import { EventVisibility, GoogleEventResponseStatus, SyncRule, Transparency } from '../../utils/rule';
import { SyncRuleFormValues } from './interface';

export function getInitialSyncRuleFormValues(rule: SyncRule | null): SyncRuleFormValues {
    return {
        source: rule?.source_uuid || '',
        destination: rule?.destination_uuid || '',
        summary: rule?.summary || '%original%',
        description: rule?.description || '%original%',
        filterRule: rule?.filter_rule?.value,
        filterRuleType: rule?.filter_rule?.kind,
        filterRuleField: rule?.filter_rule?.field,
        filterIn: rule?.filter_rule?.filter_in ?? false,
        statusTransform: rule?.status_transform || {
            needs_action: GoogleEventResponseStatus.needs_action,
            declined: GoogleEventResponseStatus.declined,
            tentative: GoogleEventResponseStatus.tentative,
            accepted: GoogleEventResponseStatus.accepted,
            deleted_declined: true,
        },
        visibility: rule?.visibility || EventVisibility.KEEP_ORIGINAL,
        color: rule?.color || '0',
        keep_location: rule?.keep_location?.toString() || 'false',
        include_conference_link: rule?.include_conference_link?.toString() || 'false',
        transparency: rule?.transparency || Transparency.keep_original,
        bufferBefore: rule?.buffer?.minutes_before || 0,
        bufferAfter: rule?.buffer?.minutes_after || 0,
        includeAllDayEvents: ((): string => {
            const value = rule?.include_all_day_events;
            if (value === null || value === undefined) {
                return '1';
            }
            if (typeof value === 'boolean') {
                return value ? '1' : '3';
            }
            return value.toString();
        })(),
        maintainEventId: rule?.maintain_event_id?.toString() || 'false',
        useReminders: rule?.reminders != null,
        reminders: rule?.reminders || {
            useDefault: false,
            overrides: [],
        },
        syncPastEvents: rule?.sync_past_events ?? false,
        pastEventsLookbackDays: rule?.past_events_lookback_days ?? 30,
    };
}

export function getSyncRuleColors(t: (key: string) => string) {
    return [
        { id: '0', background: '#ffffff', name: t('dashboard.sync.colors.default') },
        { id: '8', background: '#616161', name: t('dashboard.sync.colors.graphite') },
        { id: '9', background: '#3F51B5', name: t('dashboard.sync.colors.blueberry') },
        { id: '1', background: '#7986CB', name: t('dashboard.sync.colors.lavender') },
        { id: '3', background: '#8E24AA', name: t('dashboard.sync.colors.grape') },
        { id: '7', background: '#039BE5', name: t('dashboard.sync.colors.peacock') },
        { id: '10', background: '#0B8043', name: t('dashboard.sync.colors.basil') },
        { id: '2', background: '#33B679', name: t('dashboard.sync.colors.sage') },
        { id: '5', background: '#F6BF26', name: t('dashboard.sync.colors.banana') },
        { id: '6', background: '#F4511E', name: t('dashboard.sync.colors.tangerine') },
        { id: '4', background: '#E67C73', name: t('dashboard.sync.colors.flamingo') },
        { id: '11', background: '#D50000', name: t('dashboard.sync.colors.tomato') },
    ];
}

export const GOOGLE_ORANGE = '#ff9800';
export const GOOGLE_BLUE = '#4285f4';
